import { lazy } from "react";
import { MODULE_IDS } from "../../../../../../constants/enums";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const CommAutoG4Sign = Loadable(
  lazy(() =>
    import(
      "./CommAutoG4Sign"
    ).then(({ CommAutoG4Sign }) => ({
      default: CommAutoG4Sign,
    }))
  )
);

const CommAutoG4SignManageDocument = Loadable(
  lazy(() =>
    import(
      "./CommAutoSignG4ManageDocument"
    ).then(({ CommAutoG4SignManageDocument }) => ({
      default: CommAutoG4SignManageDocument,
    }))
  )
);



export const CommAutoG4SignRouter = [
       {
            path: "/comm-automobile-policy/:customerId/g4-sign/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
               <CommAutoG4Sign/>
              </AuthorizedRoute>
            ),
          },
           {
            path: "/comm-automobile-policy/:customerId/g4-sign/:customerPolicyId/manage",
            exact: true,
            element: ( 
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
               <CommAutoG4SignManageDocument/>
              </AuthorizedRoute>
            ),
          },
           {
            path: "/comm-automobile-policy/:customerId/g4-sign/:customerPolicyId/manage/:documentCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                 <CommAutoG4SignManageDocument/>
              </AuthorizedRoute>
            ),
          },

]